import awsconfig from '../aws-exports'

// Der Amplify-Branchname ($AWS_BRANCH, gesetzt in amplify.yml). Bewusst NICHT
// als Stage verwenden: auf Feature-Branch-Deploys ist das der Branchname, nicht
// 'develop' | 'staging' | 'production'. Nur noch fuer Bugsnag-Release-Stage,
// Slack-Prefixes und die production-only Guards.
export const BUILD_ENV = process.env.REACT_APP_USER_BRANCH || 'develop'

export const STAGES = {
  DEVELOP: 'develop',
  STAGING: 'staging',
  PRODUCTION: 'production'
}

const KNOWN_STAGES = Object.values(STAGES)

// Primaerquelle. Amplify injiziert aws-exports.js pro Branch passend zur
// Backend-Zuordnung aus der Console – und nur die zaehlt: eine space_id in
// einem Invite-Link existiert ausschliesslich in genau diesem Backend. Ein
// Feature-Branch kann gegen develop deployt sein und trotzdem
// 'culture-fit-dreamteam-requirement' heissen; der Branchname sagt darueber
// nichts.
const stageFromBackend = () => {
  const bucket = awsconfig?.aws_user_files_s3_bucket

  return KNOWN_STAGES.find((stage) => bucket === `aivy-user-content-${stage}`)
}

// Fallback 1: die Custom Domain kann nicht driften, ein Branchname schon.
const stageFromHostname = () => {
  if (typeof window === 'undefined') return undefined

  const host = window.location.hostname

  // localhost und *.amplifyapp.com (Branch-Previews) fallen durch
  if (host !== 'dashboard.aivy.app' && !host.endsWith('.dashboard.aivy.app')) {
    return undefined
  }

  if (host.startsWith('develop.')) return STAGES.DEVELOP
  if (host.startsWith('staging.')) return STAGES.STAGING

  // www.dashboard.aivy.app und Kunden-Subdomains
  return STAGES.PRODUCTION
}

// Fallback 2: alles Unbekannte auf develop, nicht auf production. Ein
// Preview-Branch soll nie Production-Links ausliefern.
const stageFromBranch = () => {
  return KNOWN_STAGES.includes(BUILD_ENV) ? BUILD_ENV : STAGES.DEVELOP
}

export const STAGE =
  stageFromBackend() || stageFromHostname() || stageFromBranch()
